import React, { useState, useEffect } from 'react';
import './Carousel.css';

const Carousel = ({ projects, onProjectClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevItems, setPrevItems] = useState(new Set());
  const [exitingItem, setExitingItem] = useState(null);
  const [direction, setDirection] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const newPrevItems = new Set();
    newPrevItems.add(currentIndex);
    
    const prevIndex = (currentIndex - 1 + projects.length) % projects.length;
    const nextIndex = (currentIndex + 1) % projects.length;
    newPrevItems.add(prevIndex);
    newPrevItems.add(nextIndex);

    if (currentIndex === 0) {
      newPrevItems.add(projects.length - 1);
    } else if (currentIndex === projects.length - 1) {
      newPrevItems.add(0);
    }

    setPrevItems(newPrevItems);

    if (isTransitioning) {
      const timer = setTimeout(() => {
        setExitingItem(null);
        setDirection(null);
        setIsTransitioning(false);
      }, 800);

      return () => clearTimeout(timer);
    }
  }, [currentIndex, projects.length, isTransitioning]);

  const handleNextClick = () => {
    if (isTransitioning) return;
    
    setIsTransitioning(true);
    const nextIndex = (currentIndex + 1) % projects.length;
    setDirection('next');
    
    if (currentIndex === projects.length - 1) {
      // When going from project 5 to 1, make project 4 fade out
      setExitingItem(currentIndex - 1);
    } else {
      setExitingItem((currentIndex - 1 + projects.length) % projects.length);
    }
    
    setCurrentIndex(nextIndex);
  };

  const handlePrevClick = () => {
    if (isTransitioning) return;
    
    setIsTransitioning(true);
    const prevIndex = (currentIndex - 1 + projects.length) % projects.length;
    setDirection('prev');
    
    if (currentIndex === 0) {
      // When going from project 1 to 5, make project 2 fade out
      setExitingItem(1);
    } else {
      setExitingItem((currentIndex + 1) % projects.length);
    }
    
    setCurrentIndex(prevIndex);
  };

  const projectImages = {
    0: 'TaskManage.png',
    1: 'EmailAI.png',
    2: 'Flashcardimg.png',
    3: 'software.png',
    4: 'Galaxy.png'
  };

  return (
    <div className="carousel">
      <div className="carousel-content">
        {projects.map((project, index) => {
          const isActive = index === currentIndex;
          const isPrev = index === (currentIndex - 1 + projects.length) % projects.length;
          const isNext = index === (currentIndex + 1) % projects.length;
          const wasVisible = prevItems.has(index);
          const isExiting = index === exitingItem;
          const imageFolder = project.imagePath || 'Img/ProjectImg';
          const imageName = project.image || projectImages[index];

          return (
            <div
              key={index}
              className={`carousel-item 
                ${isActive ? 'active' : ''} 
                ${isPrev ? 'prev' : ''} 
                ${isNext ? 'next' : ''} 
                ${!wasVisible && (isPrev || isNext) ? 'fade-in' : ''}
                ${isExiting ? direction === 'next' ? 'fade-out-behind' : 'fade-out-behind-reverse' : ''}`}
              onClick={() => onProjectClick(project)}
              style={{ cursor: 'pointer' }}
            >
              <div className={`project-card ${project.isWorkProject ? 'work-project-card' : ''}`}>
                <img 
                  src={`${process.env.PUBLIC_URL}/${imageFolder}/${imageName}`}
                  alt={project.title} 
                />
                <div className="project-card-content">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="carousel-buttons">
        <button 
          className="carousel-button prev" 
          onClick={handlePrevClick}
          disabled={isTransitioning}
        >
          &lt;
        </button>
        <button 
          className="carousel-button next" 
          onClick={handleNextClick}
          disabled={isTransitioning}
        >
          &gt;
        </button>
      </div>
    </div>
  );
};

export default Carousel; 